module.exports = __webpack_public_path__ + "img/gauge-simple-low.9e8485c7.svg";